import { ageFromBirthdate, birthdateInputToIso } from './ageGate.js'
import { isPasswordRecoveryRoute } from './passwordRecoveryRoutes.js'

export const advertisingPageFamily = (pathname = '/') => {
  if (pathname.startsWith('/jogos/nexo')) return 'nexo'
  if ((pathname === '/aprender' || pathname.startsWith('/aprender/')) && !pathname.includes('exercicios-portugol-resolvidos')) return 'learning'
  if (pathname.startsWith('/baixar-visualg') || /^\/o-que-e-|^\/como-aprender-python/.test(pathname) || pathname.replace(/\/+$/, '') === '/pseudocodigo' || pathname.includes('exercicios-portugol-resolvidos')) return 'seo_download'
  return 'editor'
}

export function advertisingAge(user, now = new Date()) {
  const iso = birthdateInputToIso(user?.date_of_birth || user?.dateOfBirth)
  const [year, month, day] = iso.split('-').map(Number)
  const parsed = new Date(year, month - 1, day)
  const valid = parsed.getFullYear() === year && parsed.getMonth() === month - 1 && parsed.getDate() === day
  const age = valid ? ageFromBirthdate(iso, now) : null
  return age !== null && age >= 0 && age <= 125 ? age : null
}

export function resolveAdvertisingPolicy({ user, subscriptionStatus, consent, pathname = '/', now = new Date() }) {
  const blocked = reason => ({ eligible: false, reason, ageTreatment: null })
  if (isPasswordRecoveryRoute(pathname) || /^\/(backoffice|debug-chat|debug-offers|checkout|conta)(\/|$)/.test(pathname)) return blocked('sensitive_route')
  if (user === null || user === undefined) return blocked('auth_pending')
  if (user !== false && subscriptionStatus !== 'free') return blocked(subscriptionStatus === 'paid' ? 'premium' : 'billing_unconfirmed')
  const age = advertisingAge(user, now)
  const advertisingConsent = ['granted', 'denied'].includes(consent?.advertising) ? consent.advertising : 'unset'
  const ageTreatment = age !== null && age < 13 ? 'CHILD' : age !== null && age < 18 ? 'TEEN' : 'UNSPECIFIED'
  // Birthdates and profile data are never sent to Google.
  // UNSPECIFIED also covers unknown age, without asserting adult status.
  return {
    eligible: true,
    reason: ageTreatment === 'CHILD' ? 'child_contextual' : ageTreatment === 'TEEN' ? 'teen_contextual' : age === null ? 'unknown_contextual' : 'adult_contextual',
    ageTreatment,
    advertisingConsent,
    gamPrivacyMode: advertisingConsent !== 'granted' ? 'limited' : ageTreatment === 'UNSPECIFIED' ? 'personalized' : 'non_personalized',
  }
}
